import { ADMIN_MESSAGE_FORMATS } from '../../../../constants/messageFormats';

const STANDARD_SENDER_FORMATS = new Set([
  ADMIN_MESSAGE_FORMATS.TEXT,
  ADMIN_MESSAGE_FORMATS.IMAGE,
  ADMIN_MESSAGE_FORMATS.FILE,
]);

const ATTRIBUTABLE_ADMIN_ANNOUNCEMENT_FORMATS = new Set([
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD_CANCELLED,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD_DECLINE,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_CANCELLED,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_UPDATED,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_CANCEL_COMP_DECIDED,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_INVOICE_RESUBMISSION_REQUESTED,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_ASSIGNED,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_CHANGED,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_UNASSIGNED,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_STAGE_SEATING_SHARED,
  ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONCIERGE_RESULT,
  ADMIN_MESSAGE_FORMATS.NOTE_CREATE,
  ADMIN_MESSAGE_FORMATS.NOTE_UPDATE,
  ADMIN_MESSAGE_FORMATS.NOTE_DELETE,
  ADMIN_MESSAGE_FORMATS.TIMETABLE_CREATED,
  ADMIN_MESSAGE_FORMATS.TIMETABLE_UPDATED,
  ADMIN_MESSAGE_FORMATS.TIMETABLE_MEMO,
  ADMIN_MESSAGE_FORMATS.TIMETABLE_MEMO_ADMIN,
  ADMIN_MESSAGE_FORMATS.TIMETABLE_ANNOUNCEMENT,
  ADMIN_MESSAGE_FORMATS.TIMETABLE_ANNOUNCEMENT_ADMIN,
  ADMIN_MESSAGE_FORMATS.EVENT_MATERIAL_SHARED,
  ADMIN_MESSAGE_FORMATS.EVENT_IMAGES_ADDED,
  ADMIN_MESSAGE_FORMATS.EVENT_INFO_UPDATED,
  ADMIN_MESSAGE_FORMATS.EVENT_INFO_PUBLISHED,
  ADMIN_MESSAGE_FORMATS.EVENT_MEMBERS_PUBLISHED,
  ADMIN_MESSAGE_FORMATS.STAGE_SEATING_SHARED,
  ADMIN_MESSAGE_FORMATS.EVENT_CANCELLED,
]);

const normalizeValue = (value) => String(value == null ? '' : value).trim().toLowerCase();

const hasAdminSenderIdentity = (row) =>
  Boolean(
    row?.admin_user_id ||
      row?.sender_admin_user_id ||
      row?.admin_full_name ||
      row?.admin_display_name ||
      row?.admin_username ||
      row?.admin_name
  );

export const shouldShowAdminSenderForMessage = (message) => {
  const row = message || {};
  const messageType = normalizeValue(row.message_type);
  const senderType = normalizeValue(row.sender_type);
  const messageFormat = normalizeValue(row.message_format);
  const isAdminSender =
    messageType === 'admin_message' || senderType === 'admin' || hasAdminSenderIdentity(row);
  if (!isAdminSender || !messageFormat) return false;
  if (STANDARD_SENDER_FORMATS.has(messageFormat)) return hasAdminSenderIdentity(row);
  return ATTRIBUTABLE_ADMIN_ANNOUNCEMENT_FORMATS.has(messageFormat) && hasAdminSenderIdentity(row);
};

export const shouldExcludeAdminSenderForMessage = (message) => {
  const row = message || {};
  const messageType = normalizeValue(row.message_type);
  const messageFormat = normalizeValue(row.message_format);

  if (shouldShowAdminSenderForMessage(row)) return false;
  if (messageType === 'system_message') return true;
  if (!messageFormat) return false;
  return !STANDARD_SENDER_FORMATS.has(messageFormat);
};
